module.exports = __webpack_public_path__ + "static/media/UBXT-BUSD.f651c861.svg";